<!-- unauthorized.component.html -->
<div class="d-flex flex-column justify-content-center align-items-center vh-100 text-center bg-light">
  <h1 class="display-1 fw-bold text-warning">403</h1>
  <h2 class="mb-3">Access Denied</h2>
  <p class="mb-4 text-muted">
    You do not have permission to view this page.
  </p>
  <a routerLink="/" class="btn btn-warning btn-lg">
    <i class="bi bi-arrow-left-circle-fill me-2"></i> Go Back Home
  </a>
</div>
